import React, { useState, useEffect, useRef } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../../../components/UiElements/UiElements';
import { TextareaField, InputBaseField, ToggleButton } from '../../../../../../../components/InputField/InputField';
import { withSnackbar } from "./../../../../../../../components/Message/Alert";
import { GetUserInfo } from '../../../../../../../Services/GetUserInfo';
import DialogLoader from './../../../../../../../components/Loader/DialogLoader';
import Checkbox from "@material-ui/core/Checkbox";
import Switch from '@material-ui/core/Switch';
import { getFormatedDate } from '../../../../../../../components/Common/Extensions';

import { styled } from '@material-ui/core/styles';
function StatusSummary({ dialogOpenClose, handleClose, trackNumberDetails, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const inputFile = useRef(null);

    var user = sessionStorage.getItem('user_info');
    var userdata = JSON.parse(user).user;
    const [errorMessages, setErrorMessages] = useState({ errorComment: false, })
    const [state, setState] = useState({});
    const [loginUser] = useState(JSON.parse(GetUserInfo()).user);
    const [isLoading, setIsLoading] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const [shipmentActivityDetails, setShipmentActivityDetails] = useState([]);
    const isEmptyOrSpace = (_value) => {
        const isEmptyOrSpaces = /^\s*$/.test(_value);
        return isEmptyOrSpaces;
    }
    const saveManualComments = () => {
        let errorList = [];
        if (!state.comment || isEmptyOrSpace(state.comment)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorComment: true
            }));
            errorList.push(true);
        } else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorComment: false
            }));
        }
        if (errorList.length < 1) {
            setIsLoading(true);
            var comment = state.comment;
            setShipmentActivityDetails(prevDetails => [
                [{ type: 'Manual', activityDetails: comment, createDate: new Date() }],
                ...prevDetails,

            ]);
            // console.log(shipmentActivityDetails, 'Comments Details')
            setState(prevState => ({
                ...prevState,
                comment: ''
            }));
            setIsLoading(false);
        }
    }
    const FirstLetter = ({ word }) => {
        const firstLetter = word.charAt(0).toUpperCase();
        return <span>{firstLetter}</span>;
    };

    const staticData = [
        {
            approvedBy: 'Approved by Manager',
            fileAttached: 'File Attachment',
            paymentMethod: 0,
        },
        {
            approvedBy: 'Approved by Manager',
            fileAttached: 'File Attachment',
            paymentMethod: 1,
        },
        {
            approvedBy: 'Approved by Manager',
            fileAttached: 'File Attachment',
            paymentMethod: 1,
        },
    ];

    const Android12Switch = styled(Switch)(({ theme }) => ({
        padding: 8,
        '& .MuiSwitch-track': {
            borderRadius: 22 / 2,
            position: 'relative', // Added position relative to the track
            '&:before, &:after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 16,
                height: 16,
                textAlign: 'center', // Added text-align center
                lineHeight: '16px', // Added line-height to center text vertically
            },
            '&:before': {
                left: 12,
                color: theme.palette.getContrastText(theme.palette.primary.main), // Added text color
            },
            '&:after': {
                right: 12,
                color: theme.palette.getContrastText(theme.palette.primary.main), // Added text color
            },
        },
        '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
        },
    }));


    const [selected, setSelected] = useState(false);


    useEffect(() => {
    }, []);

    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                PaperComponent={DraggableComponent}
                maxWidth="md"
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Authorization</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}
                        <Scrollbars autoHeight autoHeightMax={540}>
                            <div className={classes.content}>
                                <Grid container className={classes.Container}>
                                    <Grid row xl={6} lg={6} md={12} sm={12} className={classes.paddingLeftRight}>

                                        <div className={classes.ListContain}>
                                            <div className={classes.recentActivityList}>
                                                <Grid row container lg={12} alignItems="normal">
                                                    {/* <Grid item row lg={2} className="textRight">
                                                        <div className={classes.userDetail}>
                                                            <FirstLetter word={userdata.firstName} />     <FirstLetter word={userdata.lastName} />
                                                        </div>

                                                    </Grid> */}
                                                    <Grid item row lg={12} className={classes.Authorization}
                                                    // className={classes.borderContent}
                                                    >
                                                        <div className={"UserDiv"}>
                                                            <Typography variant="h6" color="initial" className={"Ready"}>Ready</Typography>
                                                            <Checkbox inputProps={{ "aria-label": "uncontrolled-checkbox" }} />
                                                            <div className={classes.UserProfileBG}></div>
                                                            <div className={"UserInfo"}>
                                                                <Typography variant="h6" color="initial" className={"UserName"}>{userdata.firstName + ' ' + userdata.lastName}</Typography>
                                                                <h2 className={"DateTime"}>{getFormatedDate(new Date(), 'MMM DD,YYYY')} {getFormatedDate(new Date(), 'hh:mm A')}</h2>
                                                            </div>

                                                        </div>
                                                        <div className={"UserDiv2"}>
                                                            <Typography variant="h6" color="initial" className={"Ready"}>Admin Approval</Typography>
                                                            <ToggleButton
                                                                selected={selected}
                                                                toggleSelected={() => {
                                                                    setSelected(!selected);
                                                                }}
                                                            />

                                                        </div>

                                                        <div className={"UserDiv2"}>
                                                            <Typography variant="h6" color="initial" className={"Ready"}>Attachment document</Typography>
                                                            <input
                                                                ref={inputFile}
                                                                id="bannerImg"
                                                                name="bannerImg"
                                                                type="file"
                                                                disabled={false}
                                                                maxLength={80}
                                                                style={{ display: 'none' }}
                                                            />
                                                            <div className={classes.BrowseMain}>
                                                                <InputBaseField
                                                                    type="text"
                                                                    // placeholder="Please Select your file here"
                                                                    maxLength={80}
                                                                    className={classes.fileInput}
                                                                    readOnly={true}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    onDrop={(e) => e.preventDefault()}
                                                                    onFocus={() => inputFile.current.click()}
                                                                />
                                                                <a onClick={() => inputFile.current.click()} className={'BrowseButton'}>
                                                                    Choose File
                                                                </a>
                                                            </div>


                                                        </div>
                                                        <Label title="Comments" size={12} />
                                                        <TextareaField
                                                            name="comment"
                                                            rows={3}
                                                            placeholder="Leave a Comment"
                                                            MaxLength="2000"
                                                            onChange={handleChange}
                                                            value={state.comment}
                                                        ></TextareaField>
                                                        <div className={classes.floatRight}>
                                                            <Button className={classes.changeBtn} onClick={saveManualComments}>Comment</Button>
                                                        </div>
                                                        {/* {errorMessages.errorComment && (!state.comment || isEmptyOrSpace(state.comment)) ? (<FormHelperText style={{ color: "red" }} >
                                                            Please enter comment
                                                        </FormHelperText>) : ('')} */}
                                                    </Grid>

                                                </Grid>
                                            </div>
                                        </div>
                                    </Grid>



                                    <Grid row xl={6} lg={6} md={12} sm={12} className={classes.paddingLeftRight}>
                                        <div className={classes.ListContain}>
                                            {staticData.map((activityItem, i) => (
                                                <div className={classes.recentActivityList} key={i}>
                                                    <Grid row container lg={12}>
                                                        <Grid item row lg={2} className="textRight"> <div style={{
                                                            background: activityItem.paymentMethod === 1 ? '#8A89D7' : '#FF2929',
                                                        }} className={classes.userDetails}></div> </Grid>
                                                        <Grid item row lg={9} className={classes.borderContent}>
                                                            <div className={classes.flexRow}>
                                                                <div style={{
                                                                    fontSize: '16px',
                                                                    whiteSpace: 'break-spaces',
                                                                    width: '80%',
                                                                    textAlign: 'justify',
                                                                }}>
                                                                    <div className={classes.approvedBy}>{activityItem.approvedBy}</div>
                                                                    <div className={classes.fileAttached}>{activityItem.fileAttached}</div>
                                                                    <div className={classes.paymentMethod}>{activityItem.paymentMethod === 1 ? 'Payment method is approved now' : 'This payment is not verified'}</div>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            ))}
                                        </div>
                                    </Grid>




                                    {/* <Grid row xl={6} lg={6} md={12} sm={12} className={classes.paddingLeftRight}>

                                        <div className={classes.ListContain}>
                                            {staticData.map((item, i) => {
                                                return (
                                                    <>
                                                        {item.map((activityItem, i) => {
                                                            return (
                                                                <>
                                                                    <div className={classes.recentActivityList}>
                                                                        <Grid row container lg={12}>
                                                                            <Grid item row lg={2} className="textRight"> <div className={classes.userDetails}></div> </Grid>
                                                                            <Grid item row lg={9} className={classes.borderContent}>
                                                                                <div className={classes.flexRow}>
                                                                                    <div style={{
                                                                                        fontSize: '16px',
                                                                                        whiteSpace: 'break-spaces',
                                                                                        width: '80%',
                                                                                        textAlign: 'justify'
                                                                                    }}>
                                                                                        {activityItem.activityDetails}
                                                                                        <h2>{getFormatedDate(item[0].createDate, 'MMM DD,YYYY')}</h2>
                                                                                    </div>
                                                                                    <span className={classes.contentTime}>
                                                                                        {getFormatedDate(item[0].createDate, 'hh:mm A')}
                                                                                    </span>
                                                                                </div>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </Grid> */}
                                </Grid>
                            </div>
                        </Scrollbars>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(StatusSummary);